import datetime from './data/datetime';
import processOptions from './data/processOptions';
import { truncateData } from './data/processSeries';
import * as preload from './style/preload';
import * as OuterChart from './outer/';
import * as InnerChart from './inner/';
import * as element from './util/element';

import Highcharts from 'highcharts';
import Annotations from 'highcharts/modules/annotations';
import HighChartsStock from '../../node_modules/highcharts/highstock.js';
Annotations(Highcharts);
Annotations(HighChartsStock);
// Store charts so they can be destroyed as needed.
let charts = [];

/**
 * Public API functions.
 */
function render(options, done) {
  done = (typeof done === 'function') ? done : (() => {});
  options = options.irregularDates ? processOptions(options, HighChartsStock) : processOptions(options, Highcharts);
  const invalidated = (options.invalidated && options.invalidated[options.size]);
  if (!!invalidated) {
    const existChart = getExistChart(options.el).chart;
    if (existChart && existChart.outer && existChart.inner) {
      renderInvalidated(existChart, options, done);
      return;
    }
  }
  resetRender(options, done);
}

function resetRender(options, done) {
  destroy(options.el);
  // console.log(`CHART.${options.id}.fonts.START`);
  preload.fonts(options, () => {
    // console.log(`CHART.${options.id}.fonts.COMPLETE`);
    renderChart(options, done);
  });
}

// Instead of re-rendering the entirety of both inner and outer charts, only
// the invalidate parts of re-rendered.
// TODO: Create preview/editing views and get this working again.
function renderInvalidated(rendered, options, done) {
  if (__ALL__) {
    let invalidated = options.invalidated[options.size] || [];

    const invalidAll = [
      'chart/targets',
      'chart/height',
      'chart/annotations',
    // ];
    // const invalidChart = [
      'chart/data',
      'chart/type',
      'chart/series-names',
      'chart/hide-legend',
      'chart/axis',
      'chart/legend',
      'chart/stacking',
      'chart/height',
      'chart/colors',
      'headings/title',
    ];
    const invalidChart = [];

    // Some changes require a full chart re-render while others can force a
    // more limited re-render.
    const mustRender = function (invalidated, renderItems) {
      return true;
      // return renderItems.some(item => {
      //   return invalidated.indexOf(item) !== -1 || invalidated.some(invItem => {
      //     return invItem.indexOf(item) === 0;
      //   });
      // });
    };

    if (mustRender(invalidated, invalidAll)) {
      window.__charts_fonts_loaded__ = undefined;
      resetRender(options, done);
      return;
    }

    // Some items only force a re-render under specific conditions. For example,
    // changes to series name should only trigger a re-render if the legend is
    // enabled since that is the only place where series names appear.
    invalidated = invalidated.filter(item => {
      switch (item) {
        case 'chart/series-names':
          return options.legend.enabled;
        default:
          return true;
      }
    });

    const outerHeight = rendered.outerInfo.height;
    OuterChart.renderInvalidated(rendered, options, invalidated);

    if (outerHeight !== rendered.outerInfo.height ||
        mustRender(invalidated, invalidChart)) {
        // mustRenderColor(invalidated)) {
      destroyInner(rendered.inner);
      setTimeout(() => {
        renderInnerChart(options, rendered, rendered.outerInfo, done);
      }, 1);
    } else {
      InnerChart.renderInvalidated(rendered, options, invalidated);
      done(rendered.inner);
    }
  }
}



// The outer chart containers headlines and notes.
function renderChart(options, done) {
  if (options.type === 'bar') {
    // options = truncateData(options, options.series);
  }
  let renderObj = { el: options.el, outer: null, inner: null, options };
  let chartObj = OuterChart.preRender(options);
  charts.push(renderObj);
  renderObj.outer = renderHighchart(options, chartObj, highchart => {
    let outer = OuterChart.postRender(highchart, options);
    renderObj.outerInfo = outer;
    if (outer.innerEl) {
      renderInnerChart(options, renderObj, outer, done);
    } else {
      done(null);
    }
  });
}


// The inner charts contains the actual chart.
function renderInnerChart(options, renderObj, outer, done) {
  const outerY = outer.y;
  options.width = outer.width;
  const fontSize = parseFloat(options.styles.normal.fontSize);
  if (options.size.indexOf('thumb') !== 0) {
    options.height = outer.height - ((options.type === 'pie' || options.size === 'marketwatch-ZT') ? 0 : 16);
  }
  options.height += 8;
  options.spacing = createInnerSpacing(options, outer.spacing);
  const chartObj = InnerChart.preRender(options);
  getHighchart(options, chartObj).then(highchart => {
    InnerChart.postRender(highchart, options);
    const hc = chartObj.chart.renderTo.querySelector('.highcharts-container');
    if (hc) {
      hc.style.position = 'absolute';
      hc.style.left = outer.x + 'px';
      hc.style.top = outerY + 'px';
      hc.style.overflow = 'visible';

      const svg = hc.querySelector('svg');
      svg.setAttribute('x', outer.x);
      svg.setAttribute('y', outerY);
      svg.setAttribute('height', Math.max(0, options.height + fontSize));

      if (options.size.indexOf('print') === 0) {
        // This causes tooltip issues, but needs to be done (at the time) for
        // image export and svg download:
        outer.innerEl.appendChild(svg);
        element.removeChild(hc);
      }
    }
    done(highchart);
  });
}

function getHighchart(options, data) {
  return new Promise((resolve, reject) => resolve(renderHighchart(options, data)));
}

// async function getHighchart(options, data) {
//   const newChart = await renderHighchart(options, data);
//   return newChart;
// }

function createInnerSpacing(options, spacing) {
  const inner = spacing ? spacing.map(n => n) : [0, 0, 0, 0];
  if (options.annotations.items && options.annotations.items.length &&
    (options.axes.units.suffix.length > 2 || options.axes.showRecessions)) {
    inner[0] += options.product === 'wsj' ? 24 : parseFloat(options.styles.normal.lineHeight);
    inner[0] = Math.max(0, inner[0]);
  }
  return inner;
}

// Render a Highcharts chart via either the standalone Highcharts adapter or
// jQuery, depending on the environment.
function renderHighchart(options, data, postRender) {
  if (options.irregularDates) {
    return new HighChartsStock.stockChart(data, postRender);
  } else {
    return new Highcharts.chart(data, postRender);
  }  
}

function destroy(el) {
  if (el) {
    const obj = getExistChart(el);
    if (obj.chart) {
      destroyOuter(obj.chart.outer, obj.chart.inner);
    }
    if (obj.index !== -1) {
      charts.splice(obj.index, 1);
    }
  } else {
    // charts.forEach(c => {
    //   if (c.el) {
    //     destroy(c.el);
    //   }
    // });
    while (charts.length) {
      destroy(charts[0].el);
    }
  }
}

function destroyOuter(outer, inner) {
  destroyInner(inner);
  if (outer) {
    try {
      destroyCommon(outer);
      outer.destroy();
    } catch (e) {
      // Highcharts error.... because older version?
      // console.warn(e);
    }
  }
}

function destroyInner(inner) {
  if (inner) {
    try {
      destroyCommon(inner);
      inner.destroy();
    } catch (e) {
      // Usually exception caused by no innerEl !?!
      // console.warn(e);
    }
  }
}

// The version of Highcharts used at DJ does not do this automatically.
function destroyCommon(chart) {
  if (chart.series) {
    chart.series.forEach(s => {
      try {
        s.update({
          enableMouseTracking: false
        });
      } catch (e) {
        //
      }
    });
  }
}


function getExistChart(el) {
  const existChartIndex = chartIndexOf(el);
  return {
    index: existChartIndex,
    chart: (existChartIndex !== -1) ? charts[existChartIndex] : null
  };
}

function chartIndexOf(el) {
  for (let i = 0; i < charts.length; i++) {
    if (charts[i].el === el) {
      return i;
    }
  }
  return -1;
}

export default { render, destroy, datetime, chart: getExistChart };



// WEBPACK FOOTER //
// ./src/chart/index.js